import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import Seo from "@/components/site/Seo";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import ServiceArea from "@/components/site/ServiceArea";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import CTABand from "@/components/site/CTABand";
import Footer from "@/components/site/Footer";
import StickyCallBar from "@/components/site/StickyCallBar";
import QuoteForm from "@/components/site/QuoteForm";

export default function Home() {
  const [modal, setModal] = useState(false);
  const openQuote = () => setModal(true);

  return (
    <div className="bg-obsidian min-h-screen">
      <Seo />
      <Header onQuote={openQuote} />
      <main>
        <Hero />
        <Services onQuote={openQuote} />
        <WhyChooseUs />
        <ServiceArea onQuote={openQuote} />
        <Testimonials />
        <FAQ />
        <CTABand onQuote={openQuote} />
      </main>
      <Footer />
      <StickyCallBar onQuote={openQuote} />

      <AnimatePresence>
        {modal && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            data-testid="quote-modal"
            className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto"
          data-lenis-prevent
            onClick={() => setModal(false)}
          >
            <motion.div
              initial={{ scale: 0.95, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 20 }}
              onClick={(e) => e.stopPropagation()}
              className="relative bg-carbon border border-white/10 rounded-md p-6 sm:p-8 w-full max-w-md my-8"
            >
              <button onClick={() => setModal(false)} data-testid="quote-modal-close"
                className="absolute top-4 right-4 text-zinc-400 hover:text-white">
                <X className="w-5 h-5" />
              </button>
              <h2 className="text-2xl font-display font-bold text-white mb-1">Free Roof Evaluation</h2>
              <p className="text-sm text-zinc-400 mb-5">Fixed, no-hassle pricing in 30 seconds.</p>
              <QuoteForm onSuccess={() => {}} />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
